/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { UniswapV2Router02 } from "../UniswapV2Router02";

export class UniswapV2Router02__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _factory: string,
    _WETH: string,
    overrides?: Overrides
  ): Promise<UniswapV2Router02> {
    return super.deploy(
      _factory,
      _WETH,
      overrides || {}
    ) as Promise<UniswapV2Router02>;
  }
  getDeployTransaction(
    _factory: string,
    _WETH: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(_factory, _WETH, overrides || {});
  }
  attach(address: string): UniswapV2Router02 {
    return super.attach(address) as UniswapV2Router02;
  }
  connect(signer: Signer): UniswapV2Router02__factory {
    return super.connect(signer) as UniswapV2Router02__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): UniswapV2Router02 {
    return new Contract(address, _abi, signerOrProvider) as UniswapV2Router02;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_factory",
        type: "address",
      },
      {
        internalType: "address",
        name: "_WETH",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "WETH",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address",
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountADesired",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountBDesired",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "addLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountTokenDesired",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "addLiquidityETH",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "reserveIn",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "reserveOut",
        type: "uint256",
      },
    ],
    name: "getAmountIn",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "reserveIn",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "reserveOut",
        type: "uint256",
      },
    ],
    name: "getAmountOut",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
    ],
    name: "getAmountsIn",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
    ],
    name: "getAmountsOut",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "reserveA",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "reserveB",
        type: "uint256",
      },
    ],
    name: "quote",
    outputs: [
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address",
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "removeLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "removeLiquidityETH",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "removeLiquidityETHSupportingFeeOnTransferTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "removeLiquidityETHWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "removeLiquidityETHWithPermitSupportingFeeOnTransferTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address",
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "removeLiquidityWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "swapETHForExactTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "swapExactETHForTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "swapExactETHForTokensSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "swapExactTokensForETH",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "swapExactTokensForETHSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "swapExactTokensForTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "swapExactTokensForTokensSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "swapTokensForExactETH",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "swapTokensForExactTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";
